import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff, Lock, Person } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Credenciales incorrectas');
    }
    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0047AB 0%, #00A3FF 100%)',
      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
    }}>
      <Card sx={{ width: 420, p: 2, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <CardContent>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h3" sx={{
              fontWeight: 800, background: 'linear-gradient(135deg, #0047AB, #00A3FF)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: 3
            }}>UNIFIX</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Plataforma de Licitaciones
            </Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField fullWidth label="Usuario" value={username} onChange={e => setUsername(e.target.value)}
              sx={{ mb: 2 }} InputProps={{
                startAdornment: <InputAdornment position="start"><Person /></InputAdornment>
              }} />
            <TextField fullWidth label="Contraseña" type={showPassword ? 'text' : 'password'}
              value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 3 }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><Lock /></InputAdornment>,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }} />
            <Button fullWidth variant="contained" type="submit" size="large" disabled={loading}
              sx={{ py: 1.5, fontSize: 16 }}>
              {loading ? 'Ingresando...' : 'Iniciar Sesión'}
            </Button>
          </form>
        </CardContent>
      </Card>
      <Typography variant="body2" sx={{ mt: 3, color: 'white', opacity: 0.8 }}>
        Unifix SPA - Todos los derechos reservados
      </Typography>
    </Box>
  );
}
